const getIndexById = ({ array, id }) => {
  return array.findIndex(entry => entry.id === id);
};

export { getIndexById };
